export default {
  addComments(state, comments) {
    state.comments = [...state.comments, ...comments];
  },
  setComments(state, comments) {
    state.comments = comments;
  },
  setCount(state, count) {
    state.count = count;
  }
};
